import { render, staticRenderFns } from "./BaseLoadingAnimation.vue?vue&type=template&id=54ea35e6&scoped=true&"
import script from "./BaseLoadingAnimation.vue?vue&type=script&lang=ts&"
export * from "./BaseLoadingAnimation.vue?vue&type=script&lang=ts&"
import style0 from "./BaseLoadingAnimation.vue?vue&type=style&index=0&id=54ea35e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ea35e6",
  null
  
)

export default component.exports